
var previousPageFlag=false;
var dummyFlag=false;
class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.accordionType = this.dataset.accordiontype;
    this.filterParent = this.closest('#filtersCollapse');
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.filterForm = this.querySelector('form');
    this.quickshop = document.querySelector('quick-shop');
    this.filterType = this.dataset.filtertype;

    const toggleBtns = this.querySelectorAll('.filter__toggle');
    toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));

    // ADA: Add keyboard support (Enter/Space) for filter checkboxes
    const filterCheckboxes = this.querySelectorAll('.form-check-input[type="checkbox"]');
    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('keydown', (event) => {
        if (event.code === 'Enter') {
          event.preventDefault();
          checkbox.checked = !checkbox.checked;
          // Trigger input event to apply the filter
          checkbox.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });

    /*********** Open Drawer on Filter or SortBy button click. Close Drawer on close button click *************/
    this.openFilterDrawer = document.getElementById('filter-drawer');
    if(this.openFilterDrawer) this.openFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.openSortbyDrawer = document.getElementById('sortby-drawer');
    if(this.openSortbyDrawer) this.openSortbyDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.closeFilterDrawer = this.filterParent.querySelector('.collection-filters-close');
    if(this.closeFilterDrawer) this.closeFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    if(this.filterType == 'horizontal-filters'){
      document.body.addEventListener('click', (event)=>{
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.filter__toggle').click();
        })
      });
      const filterContainers = document.querySelectorAll('.filter__container');
      filterContainers.forEach((target) => {
        target.addEventListener('click', (event)=>{
          event.stopPropagation();
        });
      });
    }
    /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/

    this.sortby_values = document.querySelectorAll('[data-sortby] .sortby_options');
    this.sortby_values.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    this.subCollectionLinks = document.querySelectorAll('[data-subCollections] .collection-entry');
    this.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    this.filterParent.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE'){ this.closeFilterDrawer.dispatchEvent(new Event('click')); }
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
       this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    const applyBtn = this.querySelector('[data-applyFilters]');
    if(applyBtn){
      
      applyBtn.addEventListener('click', () => {
        this.filterForm.dispatchEvent(new Event('submit', {'bubbles' : true, 'cancelable' : true }));
        setTimeout(() => {
          this.closeFilterDrawer.dispatchEvent(new Event('click'));
        }, 200);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagination]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    const paginationBackLinks = document.querySelectorAll('[data-back-pagination]');
    paginationBackLinks.forEach(link => link.addEventListener('click', this._manageBackPagination.bind(this)));

    this.bindActiveFilterButtonEvents();
    this.addAccessibilityAttributes(toggleBtns);
    this.colorOptionsStyling();

    this._scrollToProduct();
    this.loadSubitems()
    this.checkCards();
    
    // Apply color variant from URL on initial page load
    this.applyColorFromURL();

    previousPageFlag=false;
  }

  /**
   * Filter Block Toggle event
   * @param {NodeList} toggleBtns Open filter block buttons
   */
  addAccessibilityAttributes(toggleBtns) {
    toggleBtns.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  _scrollToProduct() {
    document.querySelectorAll('[data-pr-id]').forEach(ele => {
      ele.addEventListener('click',(event)=>{
        let prId=ele.getAttribute('data-pr-id');
        localStorage.setItem('prId',prId);
      })
    });

    if (localStorage.getItem('prId')) {
      let prHeight=document.querySelector(`[data-pr-Id="${localStorage.getItem('prId')}"]`)?.offsetTop;
      window.scrollTo({ top: parseFloat(prHeight), behavior: 'smooth' });
      localStorage.removeItem('prId')
    }

    let sTimeOut=0
    if (!dummyFlag) {
      sTimeOut=200
    }
    window.addEventListener('scroll',(event)=>{
      event.stopImmediatePropagation();
      setTimeout(() => {
        if (!previousPageFlag && Utility.in_Viewport(document.querySelector('#prev-load-more')) && document.querySelector('#prev-load-more') != null) {
          previousPageFlag=true;
          
            document.querySelector('#prev-load-more')?.click();
            document.querySelector('#prev-load-more').style.pointerEvents="none";
            dummyFlag=true;
        }
      },sTimeOut)
    })
  }

  loadSubitems() {
    document.querySelectorAll('.is-subitem').forEach(subitem => {
      subitem.classList.remove('is-subitem-active');
    });
    document.querySelectorAll('.form-check-input:checked').forEach(filter => {
      document.querySelectorAll(`.group-${filter.value}`).forEach(subitem => {
          subitem.classList.add('is-subitem-active');
      });
    });
  }
  checkCards() {
    if (location.search) {
      document.querySelectorAll('.collection-infocard').forEach(card => card.classList.add("d-sm-none", "d-md-none", "d-lg-none", "d-xl-none"));
    } else {
      document.querySelectorAll('.collection-infocard').forEach(card => card.classList.remove("d-sm-none", "d-md-none", "d-lg-none", "d-xl-none"));
    }
  }
  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    //if(event.type == 'input' && this.filterParent.classList.contains('filter-active')){
      //return;
    //}
    if (!event.target.checked) {


      document.querySelectorAll(`.group-${event.target.value}`).forEach(subitem => {


        subitem.querySelector('input').checked = false;


      });


    }
    let closestForm = document.getElementById('CollectionFiltersForm');
    if(event.target && event.target.closest('form')){ closestForm = event.target.closest('form'); }
    if(!closestForm) return;

    const searchParams = this._finalQueryString(closestForm)
    this.renderPage(searchParams, event);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _finalQueryString(form){
    const formData = new FormData(form);
    let searchParams = '';
    let constraints = '';
    formData.forEach((val, key) => {
      if(key.indexOf('price-list') >= 0){
        searchParams += '&' + val;
      }else if(key.indexOf('custom_sort_by') >= 0){
        //  Code for SortBy
      }else if(key.indexOf('tagsFilter-') > -1){
        if(constraints === ''){ constraints = val; }
        else{ constraints += `+${val}`; }
      }else if(val != null && val.length > 0){
        if(searchParams === ''){ searchParams = key + '=' + val;}
        else{ searchParams += '&' + key + '=' + val; }
      }
    });

    if(constraints != ''){
      if(searchParams == ''){
        searchParams = `?constraint=${constraints}`;
      }else{
        searchParams += `&constraint=${constraints}`;
      }
    }

    return searchParams;
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = this.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    let currentTarget = event.target;
    let URLString = null;
    if(currentTarget.dataset.type == 'tag_based'){
      const inputValue = currentTarget.dataset.remove;
      const inputElement  = document.querySelector(`input[data-tagslist][value="${inputValue}"]`);
      if(inputElement) inputElement.checked = false;

      let closestForm = document.getElementById('CollectionFiltersForm');
      if(!closestForm) return;
      URLString = this._finalQueryString(closestForm);
    }else{
      if(!currentTarget.classList.contains('filter-option-clear')){ 
        currentTarget = event.target.closest('.filter-option-clear');
        URLString = new URL(currentTarget.href).searchParams.toString();
      };
    }
    if(URLString != null)
      this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  renderPage(searchParams, event, updateURLHash = true) {
    event.stopImmediatePropagation();
    document.getElementById('collection-product-grid').querySelector('#template-collection').classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderGridFromFetch(url, type) {
    document.querySelector('.collection-filter-grid').classList.add('is-loading');
    if(!url) return;
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html, type);
      });
  }

  renderProductGrid(html, type) {
    const innerHTML = new DOMParser().parseFromString(html, 'text/html');
    let infocardElements = document.querySelectorAll('.collection-infocard');
    if (document.querySelector('#prev-load-more') != null) {
      document.querySelector('#prev-load-more').style.pointerEvents="all";
      previousPageFlag=false;
    }
    let paginationType = 'numbers';
    if(document.querySelector('[data-pagination]')){
      paginationType = document.querySelector('[data-pagination]').dataset.type || 'numbers';
    }
    if(type == 'filter' || type == 'sub_collection_filter'){
      const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
      document.getElementById('collection-product-grid').innerHTML = gridHTML;

      if(type == 'sub_collection_filter'){
        let bannerHTML = innerHTML.querySelector('[data-collectionBanner]').innerHTML;
        document.querySelector('[data-collectionBanner]').innerHTML = bannerHTML;
      }
    }else{
      if (window.isPrevPagination !== undefined && window.isPrevPagination == true) {
        if(paginationType == 'loadmore'){
          let productGrids = innerHTML.getElementById('template-collection').innerHTML;
          let loadMoreBtn =  innerHTML.querySelector('#prev-load-more');
          (innerHTML.querySelector('#prev-load-more') != null) && innerHTML.querySelector('#prev-load-more').remove();
          document.getElementById('template-collection').insertAdjacentHTML('afterbegin', productGrids);
          if(loadMoreBtn && document.querySelector('#prev-load-more')){ 
            document.querySelector('#prev-load-more').parentNode.replaceChild(loadMoreBtn, document.querySelector('#prev-load-more')); 
          }
          else if(document.querySelector('#prev-load-more')){ document.querySelector('#prev-load-more').remove(); }
        }else{
          const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
          document.getElementById('collection-product-grid').innerHTML = gridHTML;
        }
        window.isPrevPagination = false;
      }else{
        if(paginationType == 'loadmore'){
          let productGrids = innerHTML.getElementById('template-collection').innerHTML;
          let loadMoreBtn =  innerHTML.getElementById('load-more');
          if(innerHTML.querySelector('#prev-load-more') != null) innerHTML.querySelector('#prev-load-more').remove();
          document.getElementById('template-collection').insertAdjacentHTML('beforeend', productGrids);
          if(loadMoreBtn && document.getElementById('load-more')){ 
            document.getElementById('load-more').parentNode.replaceChild(loadMoreBtn, document.getElementById('load-more')); 
          }
          else if(document.getElementById('load-more')){ document.getElementById('load-more').remove(); }
        }else{
          const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
          document.getElementById('collection-product-grid').innerHTML = gridHTML;
        }
      }
      if (infocardElements.length > 0) {
        let gridContainer = document.getElementById('collection-product-grid');
        if (gridContainer) {
            infocardElements.forEach(infocard => {
                gridContainer.insertAdjacentElement('afterbegin', infocard);
            });
        }
      }
    }

    const openFilters = document.querySelectorAll('.filter__container.open');
    const filterInnerHTML = innerHTML.getElementById('main-collection-filters').innerHTML;
    document.getElementById('main-collection-filters').innerHTML = filterInnerHTML;

    if(this.filterType != 'horizontal-filters'){
      // reopen filter blocks which are active before HTML update
      openFilters.forEach(openFilter => {
        if(openFilter.querySelector('.filter__toggle')){
          openFilter.querySelector('.filter__toggle').setAttribute('aria-expanded', true);
        }
        let filterBlock = document.querySelector('.filter__container[data-index="'+openFilter.dataset.index+'"]');
        filterBlock.classList.add('open');
        filterBlock.querySelector('.filter__block').classList.add('open');
      });
    }

    const filterContainers = document.querySelectorAll('.filter__container');
    filterContainers.forEach(filter => {
      const tagList = filter.querySelectorAll('.filter__item');
      if(tagList.length <= 0){
        filter.classList.add('d-none');
        filter.style.display = 'none';
      }
    });
    
    const totalProducts = innerHTML.querySelector('[data-totalProducts]');
    let filteredProductCount;
    if (totalProducts != "" && totalProducts != null) {
      if (totalProducts.querySelectorAll("[product-count]").length > 0) {
        filteredProductCount = totalProducts.querySelector("[product-count]");
        filteredProductCount = filteredProductCount.innerHTML;
      filteredProductCount = filteredProductCount.replace("Results found","");
      }
       
      
    }
    let productCount = document.querySelectorAll("[data-product-grid]").length;
    // if(totalProducts) document.querySelector('[data-totalProducts]').innerHTML = totalProducts.innerHTML;
    if(totalProducts) document.querySelector('[data-totalProducts]').innerHTML =`Showing  ${productCount} of ${filteredProductCount}` ;

    const activeFilters = innerHTML.querySelector('[data-activeFilters]');
    if(activeFilters) document.querySelector('[data-activeFilters]').innerHTML = activeFilters.innerHTML;
    this.bindActiveFilterButtonEvents();
    if(this.quickshop){this.quickshop.updateEvents();}
    this._scrollToProduct();
    this.loadSubitems();
    this.checkCards();
    this.initWishlistButtons();
    document.querySelector('.collection-filter-grid').classList.remove('is-loading');
    this.initYotpo();
    
    // Apply color variant from URL after grid is rendered
    this.applyColorFromURL();

  }

  initWishlistButtons() {
    const wishlistButtons = document.querySelectorAll('.swym-button.swym-add-to-wishlist-view-product');
    if (!wishlistButtons.length) return;

    const reInit = (swat) => {
      if (swat && typeof swat.initializeActionButtons === 'function') {
        swat.initializeActionButtons('#collection-product-grid', '[data-swaction][data-with-epi]');
      }
    };

    if (window._swat) {
      reInit(window._swat);
      setTimeout(() => reInit(window._swat), 300);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(reInit);
  }

  applyColorFromURL() {
    console.log('applyColorFromURL called');
    
    // Get URL parameters
    const urlString = window.location.search;
    
    console.log('Full URL:', window.location.href);
    console.log('Query string:', urlString);
    
    if (!urlString) {
      console.log('No query string found');
      return;
    }
    
    // Find color filter parameters
    const allParams = new URLSearchParams(urlString);
    const possibleColors = [];
    
    // Check all parameters for potential color values
    for (let [key, value] of allParams) {
      console.log('URL param:', key, '=', value);
      
      // Check if it's a color-related filter (including metal filters)
      if (key.toLowerCase().includes('color') || 
          key.includes('filter.v.option') || 
          key.includes('filter.p.tag') || 
          key.includes('filter.p.m.custom.metal')) {
        // Store the value as a potential color
        console.log('  → This is a color/metal parameter, adding:', value);
        possibleColors.push(value.trim());
      }
    }
    
    console.log('Possible colors from URL:', possibleColors);
    
    if (possibleColors.length === 0) {
      console.log('No color parameters found in URL');
      return;
    }
    
    // Get all product cards
    const productCards = document.querySelectorAll("[data-product-grid]");
    console.log('Found product cards:', productCards.length);
    
    // First, ensure all images are visible by default (in case some have opacity: 0)
    productCards.forEach((card) => {
      const imgElement = card.querySelector("[data-feauredimage]");
      if (imgElement && !imgElement.style.opacity) {
        imgElement.style.opacity = '1';
      }
    });
    
    productCards.forEach((productCard, cardIndex) => {
      const colorSwatches = productCard.querySelectorAll("[data-color-swatch-options]");
      
      console.log(`Product ${cardIndex}: Found ${colorSwatches.length} color swatches`);
      
      if (colorSwatches.length === 0) return;
      
      // Get available colors for this product
      const availableColors = [];
      colorSwatches.forEach(swatch => {
        const colorInput = swatch.querySelector('[name="Color"]');
        if (colorInput) {
          availableColors.push(colorInput.value.trim().toLowerCase());
          console.log(`  Available color: "${colorInput.value}"`);
        }
      });
      
      // Try each color from URL in order they appear
      let matchFound = false;
      for (const urlColor of possibleColors) {
        // Check if this product has this color
        if (!availableColors.includes(urlColor.toLowerCase())) {
          console.log(`Product ${cardIndex}: Skipping "${urlColor}" - not available`);
          continue;
        }
        
        // Check each swatch for this product
        colorSwatches.forEach(swatch => {
          const colorInput = swatch.querySelector('[name="Color"]');
          if (!colorInput) return;
          
          const swatchColor = colorInput.value.trim();
          
          // Case-insensitive comparison
          if (swatchColor.toLowerCase() === urlColor.toLowerCase()) {
            // Found a match - switch to this color
            console.log(`✓ MATCH FOUND! Switching product ${cardIndex} to color: "${urlColor}"`);
            this.changeSwatchProgrammatically(swatch, productCard);
            matchFound = true;
          }
        });
        
        // If we found a match, stop looking for other colors for this product
        if (matchFound) break;
      }
      
      // If no match found, ensure the default image is visible
      if (!matchFound) {
        let imgElement = productCard.querySelector("[data-feauredimage]");
        if (imgElement && imgElement.style.opacity === '0') {
          imgElement.style.opacity = '1';
          console.log(`Product ${cardIndex}: No color match, ensuring image is visible`);
        }
      }
    });
  }

  changeSwatchProgrammatically(swatchElement, parentEle) {
    console.log('changeSwatchProgrammatically called for:', swatchElement);
    
    // Prevent multiple simultaneous updates on the same product
    if (parentEle.dataset.updating === 'true') {
      console.log('Already updating, skipping...');
      return;
    }
    parentEle.dataset.updating = 'true';
    
    let colorName = swatchElement.querySelector('[name="Color"]').value;
    let variant_json = parentEle.querySelector('[data-variantJSON]');
    
    if (!variant_json) {
      console.error('No variant JSON found');
      parentEle.dataset.updating = 'false';
      return;
    }
    
    let variantData = JSON.parse(variant_json.textContent);
    
    // Get video element if exists
    let videoElement = parentEle.querySelector('.card-img video');
    
    // Find the matching variant (use find to get only first match)
    // For products with multiple options (e.g., "Gold / Small"), check if color is in the title
    let matchingVariant = null;
    for (let i = 0; i < variantData.length; i++) {
      let variant = variantData[i];
      // Check exact match first, then check if color is part of multi-option title
      if (variant.title == colorName || 
          (variant.title.includes(' / ') && variant.title.split(' / ').some(opt => opt.trim() === colorName)) ||
          (variant.options && variant.options.includes(colorName))) {
        matchingVariant = variant;
        break;
      }
    }
    
    if (matchingVariant) {
      setTimeout(() => {
        try {
          parentEle.querySelector("[data-set-variant-id]").value = matchingVariant.id;
          let price = Shopify.formatMoney(matchingVariant.price, window.globalVariables.money_format);
          parentEle.querySelector("[data-currentprice]").innerHTML = price;
          
          // Always update and show the image
          let imgElement = parentEle.querySelector("[data-feauredimage]");
          if (imgElement && matchingVariant.featured_image && matchingVariant.featured_image.src) {
            imgElement.srcset = matchingVariant.featured_image.src;
            imgElement.src = matchingVariant.featured_image.src;
            imgElement.style.opacity = '1';
            console.log('Image updated to:', matchingVariant.featured_image.src);
          } else if (imgElement) {
            imgElement.style.opacity = '1';
          }
          
          // Only hide video for non-first variants
          let videoElement = parentEle.querySelector('.card-img video');
          let isFirstVariant = variantData[0] && variantData[0].id === matchingVariant.id;
          if (videoElement && !isFirstVariant) {
            videoElement.style.display = 'none';
          }
          
          // Update button state based on availability
          let addButton = parentEle.querySelector('button[name="add"]');
          let addButtonText = addButton ? addButton.querySelector('.add-text') : null;
          let isPreorder = parentEle.dataset.preorder === 'true';
          // Check if variant should show Pre-order (zero stock but continue selling)
          let isVariantPreorder = matchingVariant.available && matchingVariant.inventory_quantity <= 0 && matchingVariant.inventory_policy === 'continue';
          if (addButton && addButtonText) {
            if (matchingVariant.available) {
              addButton.disabled = false;
              addButton.classList.remove('btn-secondary');
              addButton.classList.add('btn-primary');
              // Check for bundle collection text, variant preorder, or product-level preorder
              let bundleText = addButton.dataset.bundleText;
              if (bundleText) {
                addButtonText.textContent = bundleText;
              } else if (isVariantPreorder || isPreorder) {
                addButtonText.textContent = 'Pre-Order';
              } else {
                addButtonText.textContent = 'Add to Bag';
              }
            } else {
              addButton.disabled = true;
              addButton.classList.remove('btn-primary');
              addButton.classList.add('btn-secondary');
              addButtonText.textContent = 'Sold out';
            }
          }
          
          parentEle.dataset.updating = 'false';
        } catch (error) {
          console.error('Error updating variant:', error);
          parentEle.dataset.updating = 'false';
        }
      }, 50);
    } else {
      parentEle.dataset.updating = 'false';
    }
    
    // Update radio button states - remove checked from all first
    parentEle.querySelectorAll("[data-color-swatch-options]").forEach(ele => {
      let colorEle = ele.querySelector('[name="Color"]');
      colorEle.removeAttribute("checked");
      colorEle.checked = false;
      ele.classList.remove('swatch-active'); // Remove swatch-active class
    });
    
    // Set the selected swatch as checked
    let radioButton = swatchElement.querySelector('[name="Color"]');
    radioButton.setAttribute("checked", "");
    radioButton.checked = true;
    swatchElement.classList.add('swatch-active'); // Add swatch-active class
    
    console.log('Swatch updated - checked:', radioButton.checked, 'value:', radioButton.value);
  }

  bindActiveFilterButtonEvents() {
    document.querySelectorAll('.filter-option-clear').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  updateSortBy(event){
    let _this = event.currentTarget;
    // let currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_mobile"]:checked').value;
    let currentvalue =  '';
    if(_this.name == 'custom_sort_by_desktop'){
      currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_desktop"]:checked').value;
    }

    this.querySelector('[name="sort_by"]').value = currentvalue;
    this.querySelector('[name="sort_by"]').dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));
  }

  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    let closestForm = document.getElementById('CollectionFiltersForm');
    if(_this.closest('form')){ closestForm = event.target.closest('form'); }
    const queryString = this._finalQueryString(closestForm);

    let collURL = _this.href + '?' + queryString;
    this.renderGridFromFetch(collURL, 'sub_collection_filter');
    setTimeout(() => {
      history.pushState({}, '', collURL);
    }, 200);
  }

  _managePagination(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    let _this = event.currentTarget;
    const nextPageLink = _this.href;
    this.renderGridFromFetch(nextPageLink, 'pagination');

    setTimeout(() => {
      history.pushState({}, '', nextPageLink);
    }, 200);
  }

  _manageBackPagination(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    let _this = event.currentTarget;
    const prevPageLink = _this.href;
    this.renderGridFromFetch(prevPageLink, 'pagination');
    window.isPrevPagination = true;

    setTimeout(() => {
      history.pushState({}, '', prevPageLink);
    }, 200);
  }

  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer' || button.id == 'sortby-drawer'){
      this.filterParent.classList.add('filter-active');
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      if(button.id == 'sortby-drawer'){ this.filterParent.classList.add('sortby-drawer'); }
      else{ this.filterParent.classList.remove('sortby-drawer'); }

      Utility.trapFocus(this.filterParent);
      Utility.forceFocus(this.closeFilterDrawer);
      siteOverlay.prototype.showOverlay();
    }else{
      this.filterParent.classList.remove('filter-active');
      this.filterParent.classList.remove('sortby-drawer');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(this.filterParent);
      siteOverlay.prototype.hideOverlay();
    }
  }

  toggleFilterBlock(event) {
    event.preventDefault();
    const toggleFilterBtn = event.currentTarget;
    const filterContainer = toggleFilterBtn.parentNode;
    const isOpen = filterContainer.classList.contains('open');
    isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
  }

  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(filterContainer, 'open');
    if(this.accordionType == 'single'){
      let siblingBlocks = filterContainer.parentNode.querySelectorAll('.filter__container');
      siblingBlocks.forEach(element => {
        if(element == filterContainer){ return; }
        element.classList.remove('open');
        element.querySelector('.filter__block').classList.remove('open');
        element.querySelector('.filter__toggle').setAttribute('aria-expanded', false);
      });
    }
    // ADA: Don't trap focus in filter block - allow natural tab navigation to next filter group
  }

  closeFilterBlock(toggleFilterBtn){
    const filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    // ADA: No need to remove trap focus since we're not trapping it
  }


  initYotpo() {
  try {
    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
      return;
    }
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      const container = document.getElementById('collection-product-grid') || document;
      window.yotpo.initWidgets(container);
      return;
    }
    if (window.Yotpo && window.yotpo) {
      try { new Yotpo.API(window.yotpo).refreshWidgets(); } catch(e){}
    }
  } catch (e) {
    console.warn('Yotpo re-init failed:', e);
  }
}

}

customElements.define('collection-filters', CollectionFilters);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);
